// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"646132d3","187":"b973f2a8","419":"888bef10","563":"edd3304f","787":"77188fed","942":"e342f3ab"}[chunkId] + ".chunk.js";
};